export const ISO_8601 = 'YYYY-MM-DDTHH:mm:ssZ';

export const MODAL_CLOSE_TIMEOUT = 3000; // Close modal after delay

export const MAX_PC_HEIGHT = 450;

// z-indexes
export const HEADER_ZINDEX = 99;
export const MODAL_ZINDEX = HEADER_ZINDEX + 1;
export const BLACKLIST_HEADBAND_ZINDEX = HEADER_ZINDEX - 1;
export const SO_LAYER_ZINDEX = MODAL_ZINDEX;
export const PC_ZINDEX = 4;
